(() => {
  const widget = document.getElementById('judgeme_product_reviews');
  if (!widget) return;
  const list = widget.querySelector('.jdgm-review-list');
  const nav = widget.querySelector('.jm-pagination-controls');
  const pages = Array.from({ length: 5 }, (_, i) => document.getElementById(`ionix-review-page-${i + 1}`));
  if (!list || !nav || pages.some(page => !page)) return;
  let current = 1;
  const activeStyle = nav.querySelector('[aria-current="page"]').getAttribute('style');
  const inactiveStyle = nav.querySelector('[aria-label="Go to page 2"]').getAttribute('style');
  function showPage(page) {
    if (!Number.isInteger(page) || page < 1 || page > pages.length || page === current) return;
    current = page;
    list.replaceChildren(pages[page - 1].content.cloneNode(true));
    nav.querySelectorAll('.jm-pagination-controls__button--page').forEach(button => {
      const active = Number(button.getAttribute('aria-label').split(' ').pop()) === current;
      button.classList.toggle('jm-pagination-controls__button--active', active);
      button.setAttribute('style', active ? activeStyle : inactiveStyle);
      if (active) button.setAttribute('aria-current', 'page');
      else button.removeAttribute('aria-current');
    });
    ['previous', 'next'].forEach(direction => {
      const button = nav.querySelector(`[aria-label="Go to ${direction} page"]`);
      button.disabled = direction === 'previous' ? current === 1 : current === pages.length;
      button.classList.toggle('jm-button--disabled', button.disabled);
    });
    list.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  nav.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button || button.disabled) return;
    const label = button.getAttribute('aria-label');
    if (label === 'Go to previous page') showPage(current - 1);
    else if (label === 'Go to next page') showPage(current + 1);
    else showPage(Number(label.split(' ').pop()));
  });
})();
